import ConversationEffect from "src/Animations/ConversationEffect";
import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_TO_DEMO_3 = {
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "topaz.png",
  title: `Rick effortlessly initiated the Turf \nOptimization with a button click, which \n<span style="color: #BEE3FF;">unveils a summary of clustering results \nthat actively recommends Rick with \nstrategic options</span> to how to approach and \nenhance efficiency by redrawing the \nservice area boundaries`,
  subtitle: "turf optimization DEMO",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage(408),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(406),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "TURF_OPTIMIZATION/TO_bg_4.png",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "TURF_OPTIMIZATION/TO_DEMO_3_1.png",
          imageStyle: {
            position: "absolute",
            right: "0px",
            bottom: "0px",
          },
        },
        {
          image: "TURF_OPTIMIZATION/TO_DEMO_3_2.png",
          imageStyle: {
            position: "absolute",
            right: "0px",
            bottom: "0px",
          },
        },
      ]}
      pageNumber={407}
    />
  ),
};
